module.exports = "/static/assets/e750462991209bc82f6d0ab0783943c0.png";